import React from "react";
import SoftwareList from "./components/SoftwareList";

function App() {
  return (
    <div className="min-vh-100 bg-light">
    <header className="bg-danger text-white py-3 d-flex align-items-center">
        <div className="container d-flex align-items-center">
          <img
            src="/riosat-logo.jpg" // Logo dosyası
            alt="Şirket Logosu"
            style={{ height: "50px", marginRight: "10px" }}
          />
          <h1 className="m-0">RioSat Ürünleri Yazılımları</h1>
        </div>
      </header>
      <main className="container mt-4">
        <SoftwareList />
      </main>
    </div>
  );
}

export default App;
